import _find from 'lodash/find';
import _findIndex from 'lodash/findIndex';
import './categories-of-departure.scss';
import template from './categories-of-departure.html';

class CategoriesOfDepartureComponent {
  /** @ngInject */
  constructor(
    $log, $mdDialog, $mdToast,
    SchedulePointService,
    CategoryOfDepartureService
  ) {
    this.$log = $log;
    this.$mdDialog = $mdDialog;
    this.$mdToast = $mdToast;
    this.SchedulePointService = SchedulePointService;
    this.CategoryOfDepartureService = CategoryOfDepartureService;
    this.schedulePoints = [];
    this.columnKeys = ['description'];
  }

  $onInit() {
    if (this.me.roleName === 'MANAGER') {
      this.columnKeys.push('id');
    }
  }

  $onChanges(changes) {
    if (changes.me) {
      this.me = {...this.me};
    }
  }

  add(ev) {
    const confirm = this.$mdDialog.prompt()
      .title('Dodaj nową kategorię wyjścia')
      .textContent('Wpisz nazwę swojej nowej kategorii.')
      .placeholder('Wpisz nazwę')
      .ariaLabel('Wpisz nazwę')
      .targetEvent(ev)
      .ok('Zapisz')
      .cancel('Zamknij');

    this.$mdDialog.show(confirm).then(result => {
      const category = {description: result};
      this.CategoryOfDepartureService.add(category).then(() => {
        this.$mdToast.show(
          this.$mdToast.simple()
            .textContent('Dodano kategorię')
            .position('bottom right')
            .hideDelay(3000)
        );
      })
        .catch(error => {
          this.$mdDialog.show(
            this.$mdDialog.extendError({
              locals: {error}
            })
          );
        });
    });
  }

  edit(id, ev) {
    const category = {..._find(this.categoriesOfDeparture, category => category.id === id)};
    const confirm = this.$mdDialog.prompt()
      .title('Edytuj kategorię wyjścia')
      .textContent('Zmień nazwę kategorii.')
      .placeholder('Wpisz nową nazwę')
      .ariaLabel('Wpisz nową nazwę')
      .initialValue(category.description)
      .targetEvent(ev)
      .ok('Zapisz')
      .cancel('Zamknij');

    this.$mdDialog.show(confirm).then(result => {
      category.description = result;
      this.CategoryOfDepartureService.edit(category).then(() => {
        const index = _findIndex(this.categoriesOfDeparture, item => item.id === category.id);
        this.categoriesOfDeparture[index] = category;
        this.$mdToast.show(
          this.$mdToast.simple()
            .textContent('Pomyślnie zmieniono nazwę kategorii')
            .position('bottom right')
            .hideDelay(3000)
        );
      })
        .catch(error => {
          this.$mdDialog.show(
            this.$mdDialog.extendError({
              locals: {error}
            })
          );
        });
    });
  }

  remove(id, ev) {
    ev.stopPropagation();
    this.CategoryOfDepartureService.delete(id).then(() => {
      this.$mdToast.show(
        this.$mdToast.simple()
          .textContent('Usunięto kategorię')
          .position('bottom right')
          .hideDelay(3000)
      );
    })
      .catch(error => {
        this.$mdDialog.show(
          this.$mdDialog.extendError({
            locals: {error}
          })
        );
      });
  }

  hasAccess(id) {
    const category = _find(this.categoriesOfDeparture, category => category.id === id);
    if (category && category.isSystem) {
      return false;
    }

    return true;
  }
}
export const CategoriesOfDeparture = {
  bindings: {
    me: '<',
    categoriesOfDeparture: '<'
  },
  template,
  controller: CategoriesOfDepartureComponent
};
